export interface ThemeSettings {
  logoUrl: string | null;
  faviconUrl: string | null;
  primaryColor: string | null;
  secondaryColor: string | null;
  surfaceColor: string | null;
  textColor: string | null;
  fontHeading: string | null;
  fontBody: string | null;
}

export interface OrgResolution {
  organizationId: string;
  name: string;
  theme: ThemeSettings;
}

/**
 * FL Kitsch default theme — Shufflr brand palette.
 * Applied when no org is detected or before the org theme is fetched.
 * Orgs override this via BrandingPage → PATCH /api/v1/organizations/:id/theme.
 */
export const DEFAULT_THEME: ThemeSettings = {
  logoUrl: null,
  faviconUrl: null,
  primaryColor:   '#E8507A', // Flamingo pink
  secondaryColor: '#4BAD8F', // Seafoam green
  surfaceColor:   '#FFF8F0', // Warm cream
  textColor:      '#2D2015', // Dark warm brown
  fontHeading: '"Playfair Display", Georgia, serif',
  fontBody:    '"DM Sans", system-ui, sans-serif',
};
